import { z } from 'zod'

export const teamSchema = z.object({
  name: z.string().min(1, 'Name is required').max(191),
  description: z.string().max(2000).optional().nullable(),
  lead_user_id: z.union([z.number(), z.nan(), z.null()]).optional(),
  active: z.boolean(),
})

export type TeamFormData = z.infer<typeof teamSchema>
